import React from "react";

interface ImageProps {
  rounded?: "full" | "sm" | "md" | "lg";
  height?: number;
  width?: number;
  children?: React.ReactNode;
  backgroundcolor?: any;
  gradientColor?: string; // New prop for gradient color
  isApproved?: boolean;
  isApprovalStatus?: boolean;
  className?: string;
}

const Image = ({
  className,
  rounded,
  height,
  width,
  children,
  backgroundcolor,
  gradientColor, // Destructure the new prop
  isApproved,
}: ImageProps) => {
  const backgroundStyle = gradientColor
    ? `linear-gradient(${gradientColor})`
    : backgroundcolor;

  return (
    <div
      className={`flex rounded-${rounded} ${className} ${
        isApproved ? "bg-red-300" : "bg-gray-300"
      } p-1.5 items-center justify-center focus:outline-none transition-all duration-300 ease-in-out`}
      style={{
        background: backgroundStyle, // Use the resolved background style
      }}
    >
      {children}
    </div>
  );
};

export default Image;
